import { Component, OnInit } from '@angular/core';
import { ConfigService } from 'src/app/services/config.service';
import { NotificacionesService } from 'src/app/services/notificaciones.service';

@Component({
  selector: 'app-local-config',
  templateUrl: './local-config.component.html',
  styleUrls: ['./local-config.component.scss']
})
export class LocalConfigComponent implements OnInit {
  public linkTheme = document.querySelector('#theme');

  menuExtendido: boolean = (localStorage.getItem('menuExtendido') === 'true');
  public summaryPosition: string = localStorage.getItem('summaryPosition') || 'bottom';
  public rowsLimitStr: string = localStorage.getItem('linTablas') || '10';
  public recCuantosPedidos: string = localStorage.getItem('recCuantosPedidos') || '300';
  public recCuantosArticulos: string = localStorage.getItem('recCuantosArticulos') || '1000';
  public recCuantasEntradas: string = localStorage.getItem('recCuantasEntradas') || '100';
  imgResized: string = localStorage.getItem('imgResized') || '/resize/';

  // Voces
  public vozCajetin: boolean = localStorage.getItem('vozCajetin') === '1';
  public vozPale: boolean = localStorage.getItem('vozPale') === '1';

  public vozError: boolean = (localStorage.getItem('vozError') === '1');
  public vozSuccess: boolean = (localStorage.getItem('vozSuccess') === '1');
  public vozInfo: boolean = (localStorage.getItem('vozInfo') === '1');
  public vozWarning: boolean = (localStorage.getItem('vozWarning') === '1');

  constructor(
    private configService: ConfigService,
    private notifSrv: NotificacionesService,
  ) { }

  ngOnInit(): void {
    this.configService.marcaAcivo();
  }

  cambiaColorTema(tema: string) {
    this.configService.cambiaColorTema(tema);
    this.notificar();
  }

  cambiaMenu() {
    this.configService.menuExtendido(this.menuExtendido);
    this.notificar();
  }

  cambiaSummaryPosition() {
    this.configService.summaryPosition(this.summaryPosition);
    this.notificar();
  }

  cambiaImgResized() {
    this.configService.imgResized(this.imgResized);
    this.notificar();
  }


  rowsLimitChange() {
    this.configService.rowsLimitChange(this.rowsLimitStr);
    this.notificar();
  }

  // Número de pedidos a mostrar en la consulta
  recCuantosPedidosChange() {
    console.log('recCuantosPedidos ', this.recCuantosPedidos)
    localStorage.setItem('recCuantosPedidos', this.recCuantosPedidos);
    this.notificar();
  }

  // Número de artículos a mostrar en la consulta
  recCuantosArticulosChange() {
    console.log('recCuantosArticulos ', this.recCuantosArticulos)
    localStorage.setItem('recCuantosArticulos', this.recCuantosArticulos);
    this.notificar();
  }

  // Número de entradas a mostrar en la consulta
  recCuantasEntradasChange() {
    console.log('recCuantasEntradas ', this.recCuantasEntradas)
    localStorage.setItem('recCuantasEntradas', this.recCuantasEntradas);
    this.notificar();
  }


  // Voces:

  cambiaVozCajetin() { this.configService.vozCajetin(this.vozCajetin); this.notificar(); }
  cambiaVozPale() { this.configService.vozPale(this.vozPale); this.notificar(); }

  cambiaVozError() { this.configService.vozError(this.vozError); this.notificar(); }
  cambiaVozSuccess() { this.configService.vozSuccess(this.vozSuccess); this.notificar(); }
  cambiaVozInfo() { this.configService.vozInfo(this.vozInfo); this.notificar(); }
  cambiaVozWarning() { this.configService.vozWarning(this.vozWarning) }


  // Notificación de cambios en la configuración
  notificar() {
    this.notifSrv.aviso('success', 'Configuración guardada');
  }

}
